import * as React from 'react';
import { useRouter } from 'next/router';
import { FilterSlider } from './FilterSlider';
import { combineLinkQueryWithUrl } from '../DYHeroBanner/utils';

export interface DYSliderCTAButton {
  text: string;
  linkOrQuery: string;
}

export interface DYFilterSliderTemplateVariables {
  onClick: VoidFunction;
  data: {
    ctas: DYSliderCTAButton[];
    title: string;
    titleColor: string;
  };
}

export const DYFilterSlider: React.FC<DYFilterSliderTemplateVariables> = ({ onClick, data }) => {
  const { title, titleColor } = data;
  const { asPath } = useRouter();
  const ctas: DYSliderCTAButton[] = data.ctas.map(({ text, linkOrQuery }) => {
    return {
      text,
      linkOrQuery: combineLinkQueryWithUrl(linkOrQuery, asPath),
    };
  });

  return <FilterSlider title={title} titleColor={titleColor} ctas={ctas} onClick={onClick}></FilterSlider>;
};
